/**
 * Missing required fields error
 *
 * @param {Array<String>} missingRequiredFields
 */
export const missingRequiredFields = (requiredFields) => {
  return new Error('Missing required fields: ' + requiredFields.join(', '))
}

/**
 * Invalid value for a field error
 *
 * @param {String} error
 * @param {Integer|Boolean} row
 */
export const failedToPassRule = (error, row = false) => {
  return row
    ? new Error(`${error} (at row ${row})`)
    : new Error(error)
}
